import React from "react";
import { Button, Spinner, ButtonProps } from "@ui-kitten/components";
import { StyleSheet, View } from "react-native";

type LoadingButtonProps = ButtonProps & { isLoading: boolean };

const LoadingButton: React.FC<LoadingButtonProps> = ({
    isLoading,
    ...props
}) => {
    if (isLoading) {
        return (
            <View style={styles.spinnerContainer}>
                <Spinner />
            </View>
        );
    }
    return <Button {...props} />;
};
const styles = StyleSheet.create({
    spinnerContainer: {
        alignItems: "center",
    },
});
export default LoadingButton;
